<svelte:options tag="fds-first-config"></svelte:options>
<script>
    import {onMount, createEventDispatcher, beforeUpdate} from 'svelte'
    import {get_current_component} from "svelte/internal"

    let host = get_current_component()
    export let contentelement;
    export let open = false;
    export let initwidth = 1024;
    export let initheight = 1024;
    export let serverurl = "";
    export let bearer = "";
    export let onclosed = () => {
    };

    let svelteDispatch = createEventDispatcher();
    const dispatch = (name, detail) => {
        svelteDispatch(name, detail)
        host.dispatchEvent && host.dispatchEvent(new CustomEvent(name, {detail}))
    }
    let serverstatusurl;
    $:{
        if (serverurl) {
            if (serverurl.includes("status")) {
                serverstatusurl = serverurl 
            } else {
                if (bearer) {
                    serverstatusurl = serverurl +"/"+bearer+ "/status";
                } else {
                    serverstatusurl = serverurl + "/status";
                }
               
            }
        }
    }

    onMount(() => {
    });
    let addAndSelect = () => {
        console.log("selected: ");
        open = false;
    }


</script>
<div class="layers colorScheme">
    <fds-image-editor-dialog showclose="false" width="600px" {open}
                             onclosed={()=>{open=false; host.dispatchEvent(new CustomEvent("close", {  })); onclosed();}}>
        {#if open}
                        <span slot="modalcontent">
                            <div class="form">
                                <div class="logoline">
                                                                        <a href="#"><img
                                                                                src="appdata/gyreai.png" class="🐶" alt="Gyre Ai"></a>

                                    <!---
                                    <a href="https://www.flyingdog.de/sd" target="_blank"><img
                                            src="appdata/hundelogo_rund.png" class="🐶" alt="flying dog software"><span
                                            class="🐶Text">flying dog software</span></a>
                                
                                    <a href="https://gyre.ai" target="_blank"><img src="appdata/gyrelogo.png"
                                                                                   alt="Gyre.ai" class="🍃"><span
                                            class="🍃Text">Gyre.ai</span></a>

                                    --->
                                </div>


                            <div class="title">Image Size:</div>
                                    <div class="flexrow">
                                        <div on:click={()=>{initwidth=512;initheight=512}} class="box">512</div>
                                        <div on:click={()=>{initwidth=1024;initheight=1024}} class="box">1024</div>
                                        <div on:click={() => {initwidth=2048;initheight=2048}} class="box">2048</div>
                                    </div>

                                    <div class="formLine" style="display: flex;"><div
                                            style="initwidth: 50%; display: flex; line-height: 30px; vertical-align: middle; padding-right: 10px;">Width:
                                         <input lang="en" type="text" placeholder="512" class="formInput"
                                                bind:value={initwidth}>
                            </div> <div style="width: 50%; display: flex; line-height: 30px; vertical-align: middle;">Height:
                                         <input lang="en" type="text" placeholder="512" class="formInput"
                                                bind:value={initheight}>
                             </div></div>                            
                             <div class="formLine"><div>URL Gyre Server:</div>
                                <input lang="en" type="text" placeholder="Server URL" class="formInput"
                                       style="width:100%"
                                       bind:value={serverurl}>
                            </div>
                            <div class="formLine"><div>Token:</div>
                            <input lang="en" type="password" placeholder="Token (optional)" class="formInput"
                                   style="width:100%"
                                   bind:value={bearer}>
                            </div>                            
                            <button on:click={addAndSelect} variant="cta" class="formInput ok"
                                    style="    width: 578px;">Start</button>

                                <!-- svelte-ignore a11y-missing-attribute -->
                             <iframe id="frame" class="statusIframe"
                                     src="{serverstatusurl}"
                                     frameborder="1">
                            </iframe>
                            <a href="{serverstatusurl}" target="_blank" class="statusLink">Server Status</a>
                            </div>
                        </span>
        {/if}
    </fds-image-editor-dialog>
</div>

<style>
    .statusIframe {
        width: 800px;
        min-height: 300px;
        position: fixed;
        bottom: 20px;
        left: calc(50% - 400px);
    }

    .statusLink {
        display: none;
        width: 100px;
        bottom: 20px;
        position: fixed;
        display: block;
        left: calc(50% - 50px);
    }

    @media only screen and (max-height: 800px) {
        .statusIframe {
            display: none;
        }

        .statusLink {
            display: block;
        }

    }

    .ok {
        width: 300px;
    }

    .formLine {
        margin-bottom: 10px;
    }

    .form {
        margin-bottom: 20px;
        font-size: 14px;
    }

    a {
        text-decoration: none;
        color: white;
    }

    .logoline {
        line-height: 100px;
        text-align: center;
    }

    .🐶 {
        height: 100px;
        margin-right: 10px;
        vertical-align: middle;
    }

    .🐶Text {
        margin-right: 50px;
    }

    .🍃 {
        width: 80px;
        vertical-align: middle;
        margin-right: 10px;
    }

    .🍃Text {
        margin-right: 00px
    }

    .box {
        box-shadow: 0 0 20px 0 #333;
        background-color: rgba(255, 255, 255, 0.2);
        flex: 1 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .box:hover {
        background-color: var(--btn-selected-bgcolor);
        color: var(--btn-selected-text-color);
        transition: all .4s ease-in-out;
    }


    .flexrow {
        gap: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: stretch;
        text-align: center;
        cursor: pointer;
        padding-top: 5px;
        padding-bottom: 5px;
        height: 100px;
        margin-bottom: 10px;
    }


    
    .ok {
        cursor: pointer;
        border: 0;
        background-color: rgba(255, 255, 255, 0.2);
    }

    .ok:hover {
        background-position: 100% 0;
        transition: all .4s ease-in-out;
        box-shadow: 0 0 1rem 0 rgba(0, 0, 0, .2);
        background-color: var(--btn-selected-bgcolor);
        color: var(--btn-selected-text-color);
    }

    .formInput {
        width: 100px;
        outline: 0;
        border: 0;
        border-bottom: 2px solid rgba(255, 255, 255, 0.2);
        font-size: 14px;
        padding: 5px;
        font-weight: normal;
        border-radius: 3px;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 10px;
        display: block;

        font-family: system-ui, "Segoe UI", Roboto;
    }

    .formInput::placeholder {
        font-weight: normal;
        opacity: 0.5;
        color: rgba(255, 255, 255, 0.7);
    }

    .title {
        width: 300px;
        margin-bottom: 10px;
    }

    .colorScheme {
        --stage-color: var(--theme-stage-color);
        --btn-selected-bgcolor: var(--theme-btn-selected-bgcolor);
        --btn-selected2-bgcolor: var(--theme-btn-selected2-bgcolor);
        --btn-selected-border-color: var(--theme-btn-selected-border-color);
        --btn-text-color: var(--theme-btn-text-color);
        --btn-selected-text-color: var(--theme-btn-selected-text-color);

        --bgcolor: var(--theme-bgcolor);
        --text-color: var(--theme-text-color);
        /* Slider */
        --slider-track-bgcolor: var(--theme-slider-track-bgcolor);
        --slider-track-focus-bgcolor: var(--theme-slider-track-focus-bgcolor);
        --slider-track-border-color: var(--theme-slider-track-border-color);
        --slider-thumb-color: var(--theme-slider-thumb-color);

        --btn-bw-simple-bgcolor: #6b6b6b;
        --btn-bw-simple-bgcolor-hover: #e3ce74;
        --btn-bw-simple-color: white;
        --btn-bw-simple-color-hover: #000000;

    }
</style>

